module.exports = __webpack_public_path__ + "img/dashboard.ae27aec3.svg";